export default "__VITE_ASSET__Qvkkt5r___"